import * as React from 'react';

import moment from 'moment';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { CDP_SUGGESTED_NUM_WEEKS } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/xdp';

type Props = {
  totalDuration?: string | null;
};

const KeyInformationHorizontalCourseDurationItem = ({ totalDuration }: Props) => {
  const intl = useIntl();
  if (!totalDuration) {
    return null;
  }

  let totalHours = moment.duration(totalDuration).asHours();

  totalHours = totalHours > 1 ? Math.floor(totalHours) : 1;

  const hoursPerWeek = moment.duration(totalDuration).asHours() / CDP_SUGGESTED_NUM_WEEKS;

  return (
    <KeyInformationDetailsItem
      title={intl.formatMessage(
        _t('{totalHours, number} {totalHours, plural, =1 { hour} other { hours}} to complete'),
        {
          totalHours,
        }
      )}
      subtitle={
        hoursPerWeek >= 1
          ? intl.formatMessage(
              _t('{numWeeks} weeks at {numHours, number} {numHours, plural, =1 { hour} other { hours}} a week'),
              {
                numWeeks: CDP_SUGGESTED_NUM_WEEKS,
                numHours: Math.floor(hoursPerWeek),
              }
            )
          : undefined
      }
      numSubtitleLines={2}
    />
  );
};

export default KeyInformationHorizontalCourseDurationItem;
